import React from "react";

function HistoryTable({ headers, data }) {
  return (
    <table className="w-full min-w-[28rem]">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index} className="py-5 text-sm text-left">
              {header.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex} className="text-sm">
            {headers.map((header, colIndex) => (
              <td key={colIndex} className="py-4">
                {header.name === "from" || header.name === "amount_edx"
                  ? truncateText(row[header.name], 5) +
                    truncateTextBefore(row[header.name], 3)
                  : row[header.name]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default HistoryTable;

function truncateText(text, maxLength) {
  if (!text) {
    return "";
  }
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
}

function truncateTextBefore(text, count) {
  if (!text) {
    return "null";
  }
  return text.slice(text.length - count, text.length);
}




////// check the code